import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "error-msg-wrap" }
const _hoisted_2 = {
  class: "form-wrapper slide-up",
  style: {"width":"520px"}
}
const _hoisted_3 = { class: "form-close" }
const _hoisted_4 = { class: "pg-modal-sub" }
const _hoisted_5 = { class: "pg-number-row" }
const _hoisted_6 = {
  key: 0,
  class: "pg-hint",
  style: {"margin":"0"}
}
const _hoisted_7 = ["onUpdate:modelValue"]
const _hoisted_8 = {
  key: 2,
  class: "pg-check",
  style: {"margin-top":"18px"}
}
const _hoisted_9 = { class: "pg-seg" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 3,
  class: "pg-history"
}
const _hoisted_12 = { class: "pg-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "form-close-x",
          title: "Close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, "×")
      ]),
      _cache[11] || (_cache[11] = _createElementVNode("h2", { class: "pg-modal-title" }, "Check In", -1)),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.goal.Name), 1),
      (_ctx.goal.TrackType == 'number')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "pg-label" }, "Where Are You Now?", -1)),
            _createElementVNode("div", _hoisted_5, [
              _withDirectives(_createElementVNode("input", {
                type: "number",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentValue) = $event)),
                "aria-label": "Where you are now",
                ref: "first"
              }, null, 512), [
                [_vModelText, _ctx.currentValue]
              ]),
              _createElementVNode("span", null, "of " + _toDisplayString(_ctx.formatNumber(_ctx.goal.TargetValue)) + " " + _toDisplayString(_ctx.goal.Unit), 1)
            ])
          ], 64))
        : (_ctx.goal.TrackType == 'steps')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "pg-label" }, "Steps", -1)),
              (!_ctx.stepsDone.length)
                ? (_openBlock(), _createElementBlock("p", _hoisted_6, "This goal has no steps. Add them from the goal."))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.goal.Steps, (s, i) => {
                return (_openBlock(), _createElementBlock("label", {
                  key: i,
                  class: "pg-check"
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": ($event: any) => ((_ctx.stepsDone[i]) = $event)
                  }, null, 8, _hoisted_7), [
                    [_vModelCheckbox, _ctx.stepsDone[i]]
                  ]),
                  _createTextVNode(" " + _toDisplayString(s.Text), 1)
                ]))
              }), 128))
            ], 64))
          : (_openBlock(), _createElementBlock("label", _hoisted_8, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.done) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.done]
              ]),
              _cache[8] || (_cache[8] = _createTextVNode(" It's done ", -1))
            ])),
      _cache[12] || (_cache[12] = _createElementVNode("div", { class: "pg-label" }, "How's It Going?", -1)),
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statuses, (s) => {
          return (_openBlock(), _createElementBlock("button", {
            key: s.value,
            type: "button",
            class: _normalizeClass(_ctx.status == s.value ? 'on' : ''),
            onClick: ($event: any) => (_ctx.status = s.value)
          }, _toDisplayString(s.label), 11, _hoisted_10))
        }), 128))
      ]),
      _cache[13] || (_cache[13] = _createElementVNode("div", { class: "pg-label" }, "Note", -1)),
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.note) = $event)),
        rows: "3",
        placeholder: "What moved? What's in the way? What do you need?"
      }, null, 512), [
        [_vModelText, _ctx.note]
      ]),
      (_ctx.goal.CheckIns.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _cache[9] || (_cache[9] = _createElementVNode("b", null, "Earlier Check-Ins", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.goal.CheckIns.slice(0, 4), (c) => {
              return (_openBlock(), _createElementBlock("div", {
                key: c.ID
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.dateLabel(_ctx.isoDate(new Date(c.Date)))), 1),
                _createTextVNode(_toDisplayString(c.Note), 1)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_12, [
        _cache[10] || (_cache[10] = _createElementVNode("span", { style: {"flex":"1"} }, null, -1)),
        _createElementVNode("div", {
          class: "btn-light",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('close')))
        }, "Cancel"),
        _createElementVNode("div", {
          class: _normalizeClass(["btn", _ctx.saving ? 'disable-button' : '']),
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.save()))
        }, "Save Check-In", 2)
      ])
    ])
  ]))
}